module.exports = __webpack_public_path__ + "static/media/logo.8256727d.svg";